import { BoolFilter, useQsFilters } from "@dash/filters";
import { Button } from "@dash/form";
import { Page, PageHeader } from "@dash/page";
import { SearchWithPaginationSticky } from "@dash/search";
import { QuerySkeleton } from "@dash/skeleton";
import { parseBooleanFieldOptionToBoolean, parseBooleanToBooleanFieldOption } from "@megarax/invoices-invoice-thread";
import { MdAdd } from "react-icons/md";
import { useNavigate } from "react-router-dom-v5-compat";

import { BudgetDoc } from "@megaron/invoices-contracts";
import { useClientManager } from "@megaron/react-clients";

import { BudgetList } from "./BudgetList";
import { budgetFiltersSerializer, getMegaraxPath } from "@megaron/megarax-uri";

export const BudgetsHome = () => {
  const { filters, setFilter } = useQsFilters(budgetFiltersSerializer, {
    page: 0,
    searchText: "",
    isArchived: "any",
  });

  const navigate = useNavigate();

  const pageSize = 30;

  const searchQuery = useClientManager("docs")
    .search()
    .useQuery({
      docType: ["budget"],
      offset: (filters.page ?? 0) * pageSize,
      limit: pageSize,
      searchText: filters.searchText,
      isArchived: filters.isArchived,
    });

  return (
    <Page
      css={{
        maxWidth: "1600px",
      }}
    >
      <PageHeader
        actions={
          <Button icon={<MdAdd />} onClick={() => navigate(getMegaraxPath.uri("megarax://invoices/budgets/new"))}>
            Dodaj
          </Button>
        }
      >
        Budżety
      </PageHeader>

      <SearchWithPaginationSticky
        onSearchChange={setFilter("searchText")}
        searchValue={filters.searchText ?? ""}
        page={filters.page ?? 0}
        onPageChange={setFilter("page")}
        pageSize={pageSize}
        itemCount={searchQuery.data?.count}
        css={{
          marginBottom: "1em",
        }}
      />

      <div css={{ marginBottom: "1rem" }}>
        <BoolFilter
          label={"Jest aktywny?"}
          value={parseBooleanFieldOptionToBoolean(filters.isArchived, true)}
          onChange={(value) => setFilter("isArchived")(parseBooleanToBooleanFieldOption(value, true))}
          falseLabel="Nie"
          trueLabel="Tak"
        />
      </div>

      <QuerySkeleton query={searchQuery}>
        {(result) => <BudgetList budgets={result.items as BudgetDoc[]} />}
      </QuerySkeleton>
    </Page>
  );
};
